import { ContactForm } from "./ContactForm";
import { ContactInfo } from "./ContactInfo";
import { ContactMap } from "./ContactMap";

export const Contact = ({ data }) => {
  return (
    <div>
      <div id="contact">
        <span className="contactAnchor" id="contactAnchor" aria-hidden="true"></span>
        <div className="container">
          <div className="row">
            <ContactForm />
            <ContactInfo data={data} />
            <ContactMap />
          </div>
        </div>
      </div>
    </div>
  );
};
